import { render, staticRenderFns } from "./ClasifPharmacy.vue?vue&type=template&id=0953e65e"
import script from "./ClasifPharmacy.vue?vue&type=script&lang=js"
export * from "./ClasifPharmacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports